import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

// Components
import Container from '../../components/Container';
import Main from '../../components/Main';
import Card from '../../components/Card';
import FlightInfo from './FlightInfo';
import Aside from '../../components/Aside';
import Icon from '../../components/Icon';
import Seo from '../../components/seo';
import StepObserver from '../../components/StepObserver';
import ShieldIcon from '../../assets/icons/shield-check.svg';
import TicketPlaneIcon from '../../assets/icons/tickets-plane.svg';
import CheckIcon from '../../assets/icons/check.svg';
import '../../assets/styles/negative-advice.scss';

// Icons
import infoIcon from '../../assets/icons/info-icon-grey.svg';

// Translations
import messages from './messages';
import useDataLayer from '../../hooks/useDataLayer';
import { steps, useTranslatedNavigate } from '../../utils/routes';

const NegativeAdvice = ({ location }) => {
  const { formatMessage } = useIntl();
  const translatedNavigate = useTranslatedNavigate();
  const [pushEvent] = useDataLayer();
  const data = location?.state?.form_data?.[0];
  const description = location?.state?.description;

  function nextStep() {
    pushEvent({
      eventLabel: 'continue',
      eventAction: steps.Sorry,
    });
    translatedNavigate('/', { state: {}, replace: true });
  }

  return (
    <Container>
      <StepObserver stepName={steps.Sorry} />
      <Seo title={messages.seoTitle} description={messages.seoDescription} />
      <Main>
        <Card>
          <div className="flex flex-col" style={{ gap: '24px' }}>
            <div>
              <span className="title">
                {formatMessage(messages.flightNotEligible)}
              </span>
            </div>
            <FlightInfo data={data} description={description} />
            <div>
              <span className="subtitle">
                {formatMessage(messages.otherOptions)}
              </span>
            </div>
            <div className="box-container-options flex" style={{ gap: '14px' }}>
              <div className="container-options border-left">
                <div className="container-border flex-col">
                  <div className="flex" style={{ gap: '12px' }}>
                    <img src={ShieldIcon} width={24} height={24} />
                    <span className="box-title">
                      {formatMessage(messages.firstBoxTitle)}
                    </span>
                  </div>
                  <span className="box-subtitle">
                    {formatMessage(messages.firstBoxSubTitle)}
                  </span>
                  <div
                    className="flex-col"
                    style={{ gap: '8px', minHeight: '156px', height: 'auto' }}
                  >
                    <div>
                      <div className="flex items-start" style={{ gap: '6px' }}>
                        <img src={CheckIcon} width={24} height={24} />
                        <div className="flex-col">
                          <div style={{ marginBottom: '-5px' }}>
                            <span className="check-title">
                              {formatMessage(messages.protectClaimsBoxTitleOne)}
                            </span>
                          </div>
                          <span className="check-subtitle">
                            {formatMessage(
                              messages.protectClaimsBoxSubTitleOne
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="flex items-start" style={{ gap: '6px' }}>
                        <img src={CheckIcon} width={24} height={24} />
                        <div>
                          <div style={{ marginBottom: '-5px' }}>
                            <span className="check-title">
                              {formatMessage(messages.protectClaimsBoxTitleTwo)}
                            </span>
                          </div>
                          <span className="check-subtitle">
                            {formatMessage(
                              messages.protectClaimsBoxSubTitleTwo
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="flex items-start" style={{ gap: '6px' }}>
                        <img src={CheckIcon} width={24} height={24} />
                        <div>
                          <div style={{ marginBottom: '-5px' }}>
                            <span className="check-title">
                              {formatMessage(
                                messages.protectClaimsBoxTitleThree
                              )}
                            </span>
                          </div>
                          <span className="check-subtitle">
                            {formatMessage(
                              messages.protectClaimsBoxSubTitleThree
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className="premium-button"
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={() =>
                      (window.location.href =
                        'https://www.flight-delayed.com/en/premium')
                    }
                  >
                    {formatMessage(messages.premiumButtonText)}
                  </button>
                </div>
              </div>
              <div className="container-options">
                <div className="container-border flex-col border-right">
                  <div className="flex" style={{ gap: '12px' }}>
                    <img src={TicketPlaneIcon} width={24} height={24} />
                    <span className="box-title">
                      {formatMessage(messages.secondBoxTitle)}
                    </span>
                  </div>
                  <span className="box-subtitle">
                    {formatMessage(messages.secondBoxSubTitle)}
                  </span>
                  <div
                    className="flex-col"
                    style={{ gap: '8px', minHeight: '156px', height: 'auto' }}
                  >
                    <div>
                      <div className="flex items-start" style={{ gap: '6px' }}>
                        <img src={CheckIcon} width={24} height={24} />
                        <div className="flex-col">
                          <div style={{ marginBottom: '-5px' }}>
                            <span className="check-title">
                              {formatMessage(
                                messages.checkNextClaimsBoxTitleOne
                              )}
                            </span>
                          </div>
                          <span className="check-subtitle">
                            {formatMessage(
                              messages.checkNextClaimsBoxSubTitleOne
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="flex items-start" style={{ gap: '6px' }}>
                        <img src={CheckIcon} width={24} height={24} />
                        <div>
                          <div style={{ marginBottom: '-5px' }}>
                            <span className="check-title">
                              {formatMessage(
                                messages.checkNextClaimsBoxTitleTwo
                              )}
                            </span>
                          </div>
                          <span className="check-subtitle">
                            {formatMessage(
                              messages.checkNextClaimsBoxSubTitleTwo
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="flex items-start" style={{ gap: '6px' }}>
                        <img src={CheckIcon} width={24} height={24} />
                        <div>
                          <div style={{ marginBottom: '-5px' }}>
                            <span className="check-title">
                              {formatMessage(
                                messages.checkNextClaimsBoxTitleThree
                              )}
                            </span>
                          </div>
                          <span className="check-subtitle">
                            {formatMessage(
                              messages.checkNextClaimsBoxSubTitleThree
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button className="check-flight-button" onClick={nextStep}>
                    {formatMessage(messages.submitContinue)}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <StepTitle>
            {productType === FLIGHT_COMPENSATION &&
              formatMessage(messages.flightNotEligible)}
            {productType === TICKET_REFUND &&
              formatMessage(messages.negativeAdviceTicketRefundTitle)}
          </StepTitle> */}
          {/* <p className="sm:hidden mb-35 sm:mt-0 mx-10 sm:mx-0 text-black">
            {formatMessage(messages.asideText)}
          </p> */}
          {/* <Card onlyMobile>
            <p className="mb-35 sm:mt-0 mx-10 m-0 sm:mx-0 text-black">
              {location?.state?.description}
            </p>
          </Card> */}
        </Card>
      </Main>
      <Aside>
        <Icon src={infoIcon} className="mb-20" />
        {formatMessage(messages.asideText)}
      </Aside>
    </Container>
  );
};

NegativeAdvice.propTypes = {
  location: PropTypes.object.isRequired,
};

export default NegativeAdvice;
